import { ReactPortal, useEffect, useState } from "react";
import ReactDOM from "react-dom";

//component
import Content from "@/components/page/Content";


const ContentTranslationsPortal = (): ReactPortal | null => {
  const [targetContainer, setTargetContainer] = useState<HTMLDivElement>();
    
  let orgId: string;
  let contentId: number;
  let appGuid: string;
  
  useEffect(() => {
      setTargetContainer(document.getElementById('react-content-translations-container') as HTMLDivElement);
  },[])
  
  // Dont load if container doesnt exist
  if (!targetContainer){
    return null;
  }
  else {
    appGuid = String(targetContainer.getAttribute('data-appGuid'));
    orgId = String(targetContainer.getAttribute('data-orgId'));
    contentId = Number(targetContainer.getAttribute('data-contentId'));
  }

  return ReactDOM.createPortal(
    <Content orgId={orgId} contentId={contentId} appGuid={appGuid}/>, targetContainer
  );   
};

export default ContentTranslationsPortal;